<template>
  <div>
    <v-list>
      <v-list-tile
        v-for="(label, index) in values"
        :key="index"
        class="compact"
      >
        <v-list-tile-content>
          {{ labels[label.name].title }}
        </v-list-tile-content>
        <v-list-tile-action>
          <v-menu
            v-if="labels[label.name].variants"
            menu-props="offsetY"
          >
            <v-chip
              slot="activator"
              text-color="white"
              label
              small
              :color="getColor(label.name)"
            >
              {{ labels[label.name].variants.find(v=>v.id === labels[label.name].value).title }}
            </v-chip>

            <v-list>
              <v-list-tile
                v-for="(variant, index) in labels[label.name].variants.filter(v=>v.id !== labels[label.name].value)"
                :key="index"
                @click="changeLabel(labels[label.name].value=variant.id, label)"
              >
                <v-list-tile-title>{{ variant.description || variant.title }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
  </div>
</template>

<script>
import { updateLabel } from "../../../backend/customsEntryRegistrationApi.js";
export default {
  props: ["id", "values"],
  data() {
    return {
      labels: {
        driverHasPP: {
          title: "ПП у водителя",
          value: 0,
          variants: [
            { id: 0, title: "Нет", color: "red" },
            { id: 1, title: "Да", color: "green" },
          ],
        },
        finalInvoice: {
          title: "Финальный инвойс",
          value: 0,
          variants: [
            { id: 0, title: "Нет", color: "red" },
            { id: 1, title: "Да", color: "green" },
          ],
        },
        financialPart: {
          title: "Финансовая часть",
          value: 0,
          variants: [
            { id: 0, title: "Нет", color: "red" },
            { id: 1, title: "Да", color: "green" },
          ],
        },
      },
    };
  },
  watch: {
    values() {
      this.values.forEach((element) => {
        element.value ? (this.labels[element.name].value = 1) : 0;
      });
    },
  },
  methods: {
    async changeLabel(newValue, label) {
      await updateLabel(this.id, label.name, newValue);
      this.showInfo("Изменения сохранены");
    },
    getColor(labelName) {
      return this.labels[labelName].variants.find(
        (v) => v.id === this.labels[labelName].value,
      ).color
        ? this.labels[labelName].variants.find(
          (v) => v.id === this.labels[labelName].value,
        ).color
        : "grey";
    },
  },
};
</script>

<style>
.compact .v-chip.v-chip--label.v-chip--small {
  height: 19px;
  margin-right: 0px;
}

.compact .v-list__tile {
  padding-left: 4px;
  padding-right: 0px;
}
</style>
